import './src/main.css'
import ActiveRingChart from './src/main.vue'

export default function (Vue) {
  Vue.component(ActiveRingChart.name, ActiveRingChart)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/activeRingChart/index.js